import {
	createOperationDescriptor,
	getRequest,
	Observable,
	type Disposable,
	type GraphQLResponse,
	type GraphQLSingularResponse,
	type IEnvironment,
} from 'relay-runtime';

import paginationQuery, {
	type useAgentSessionsDataPaginationQuery$variables,
} from './__generated__/useAgentSessionsDataPaginationQuery.graphql';

/**
 * Fetch one complete response before letting Relay publish it. A failed background
 * refresh must not replace the visible connection with partial data or null.
 * The returned handle retains successful data until replaced or disposed.
 */
export const refreshAgentSessions = (
	environment: IEnvironment,
	variables: useAgentSessionsDataPaginationQuery$variables,
	onComplete: (error: Error | null) => void,
): Disposable => {
	const operation = createOperationDescriptor(getRequest(paginationQuery), variables, {
		force: true,
	});
	const retain = environment.retain(operation);
	const source = Observable.create<GraphQLResponse>((sink) => {
		let response: GraphQLSingularResponse | undefined;
		const network = environment
			.getNetwork()
			.execute(operation.request.node.params, operation.request.variables, { force: true })
			.subscribe({
				next: (payload) => {
					if (Array.isArray(payload)) {
						sink.error(new Error('Unexpected batched session response'));
						return;
					}
					const next = payload as GraphQLSingularResponse;
					if (
						('errors' in next && next.errors?.length) ||
						'path' in next ||
						'label' in next ||
						'incremental' in next
					) {
						sink.error(new Error('Incomplete session response'));
						return;
					}
					// The host adapter can append a control-only final frame.
					if (response != null && next.data == null && next.extensions?.is_final === true) {
						return;
					}
					if (response != null || next.data?.agent_sessionQuery == null) {
						sink.error(new Error('Expected one complete session connection'));
						return;
					}
					response = next;
				},
				error: (error: Error) => sink.error(error),
				complete: () => {
					if (response == null) {
						sink.error(new Error('Missing session response'));
					} else {
						sink.next(response);
						sink.complete();
					}
				},
			});
		return () => {
			response = undefined;
			network.unsubscribe();
		};
	});
	const subscription = environment.executeWithSource({ operation, source }).subscribe({
		complete: () => onComplete(null),
		error: (error: Error) => onComplete(error),
	});
	return {
		dispose: () => {
			subscription.unsubscribe();
			retain.dispose();
		},
	};
};
